import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class MetaDataService {
    constructor(private meta: Meta, private title: Title, @Inject(DOCUMENT) private document: Document) {}

    public addMetaData(obj: any, keys: string[] = ['meta_description', 'meta_keywords']): void {
        keys.forEach((key) => {
            const meta = key.replace('meta_', '');
            this.meta.updateTag({ name: meta, content: obj[key] || '' });
        });

        if (obj.meta_title) {
            this.title.setTitle(obj.meta_title);
        }
    }

    public addOgImage(): void {
        // for Facebook sharing
        this.meta.updateTag({
            property: 'og:image',
            itemprop: 'image',
            content: 'https://www.bouyguestelecom.fr/static/logo-bouygues-telecom.png',
        });
    }

    public addIndexTag(index: boolean = true, follow: boolean = true): void {
        const indexFollow = `${index ? '' : 'NO'}INDEX,${follow ? '' : 'NO'}FOLLOW`;
        this.meta.updateTag({ name: 'robots', content: indexFollow });
    }

    public useCanonicalUrl(forcedPath?: string): void {
        const linkElement = this.document.createElement('link');
        const canonicalElements = this.document.querySelectorAll('[rel="canonical"]');

        canonicalElements.forEach((element) => element.remove());

        forcedPath = this.cleanForcedPath(forcedPath);
        let currentPath = (forcedPath || window.location.pathname).replace(
            'telephones-mobiles-pro',
            'telephones-mobiles',
        );
        currentPath = currentPath.replace('hotspot-tablette-pro', 'hotspot-tablette');
        linkElement.setAttribute('rel', 'canonical');
        linkElement.setAttribute('href', `${window.location.origin}${currentPath}`);
        this.document.head.appendChild(linkElement);
    }

    public cleanForcedPath(forcedPath: string): string {
        const paramsStart = forcedPath?.indexOf('?');

        return paramsStart > -1 ? forcedPath.substring(0, paramsStart) : forcedPath;
    }
}
